// extracted by mini-css-extract-plugin
export default {"statusIcon":"Status_statusIcon__2DpGz"};